"use client"

import ProductColorButton from "@/components/common/ProductColorButton"
import ProductLabel from "@/components/common/ProductLabel"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useSelectedVariant } from "@/hooks/product_detail/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, ConfigProvider, Row, Tooltip } from "antd"

const ProductColors = () => {
  const attributes = useAppSelector(state => state.product.design_detail.data?.layout?.attributes)
  const colorAttributeIds = useAppSelector(state => state.product.design_detail.data.attributeIds['color'] || [])
  const colorAttributesData = useAppSelector(state => state.product.design_detail.data.attributesData['color'] || {})
  const variantsMapping = useAppSelector(state => state.product.design_detail.data.attributesVariantsMapping['color'] || {})
  const selectedVariant = useSelectedVariant()
  const colorsSelectionSetting = useAppSelector(state => state.store.store_setting.data.colors_selection)
  const dispatch = useAppDispatch()
  const isDesktop = useIsDesktop()

  if (!attributes || !attributes?.includes("color")) {
    return <></>
  }

  return (
    <>
      <Row>
        <ProductLabel
          labelSetting={colorsSelectionSetting.label}
          value={selectedVariant.attributes.find(attr => attr.type === 'color')?.label}
        />
      </Row>
      <Row gutter={[10, 10]}>
        {colorAttributeIds.map((attrId) => {
          const color = colorAttributesData[attrId]
          const isNotTexture = color.texture === "null" || !color.texture
          const isWhite = color.label === "White" || color.color.toLowerCase() === "#ffffff"
          const variants = variantsMapping[color.id] || []

          const colorElement = (
            <ProductColorButton
              aria-label={`Color option ${color.label}`}
              onClick={() => dispatch(productActions.selectVariant({
                type: "color",
                value: color.id
              }))}
              icon={variants.includes(`${selectedVariant.id}`) ? <FontAwesomeIcon style={{ fontSize: `${colorsSelectionSetting.size / 10}rem` }} icon={faCheck} /> : undefined}
              style={{
                ...(!isNotTexture ? { background: `url("${color.texture}")` } : {})
              }}
            />
          )
          return (
            <Col key={attrId}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: isWhite ? "#e1e2e7" : color.color
                  },
                  components: {
                    Button: {
                      controlOutlineWidth: 0
                    }
                  }
                }}
              >
                {isDesktop ? (
                  <Tooltip
                    title={color.label}
                  >
                    {colorElement}
                  </Tooltip>
                ) : (
                  <>
                    {colorElement}
                  </>
                )}
              </ConfigProvider>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductColors